/* uhren4you · Wanduhr-Berater (01.11.2026)
   Allgemeiner Fragen-Ablauf: steps[] mit Antworten, jede Antwort = Liste von Shopify-Filtern (p).
   Eine Frage pro Bildschirm, Zurück-Knopf, „Frage 2 von 5“. Ergebnis über section_id=u4y-finder-items (Meistverkauft zuerst),
   bei 0 Treffern werden Antworten in der Reihenfolge cfg.loosen gelockert. Auswahl steht im Link (#wb=0.3.1.x.2). */
(function () {
  var root = document.querySelector('[data-u4y-adv]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(document.querySelector('[data-adv-cfg]').textContent); } catch (e) { return; }
  var T = cfg.t, steps = cfg.steps;
  steps.forEach(function (s) { s.opts = s.opts.filter(function (o) { return o.k !== '_skip'; }); });
  var box = root.querySelector('[data-gf-box]');
  var res = root.querySelector('[data-gf-res]');
  var ans = {}, cur = 0;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(n, d) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); } catch (e) {}
  }
  function opt(step, k) { for (var i = 0; i < step.opts.length; i++) if (step.opts[i].k === k) return step.opts[i]; return null; }
  function stepBy(k) { for (var i = 0; i < steps.length; i++) if (steps[i].k === k) return steps[i]; return null; }
  function scrollTop() { var r = root.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 80, behavior: 'smooth' }); }

  function renderStep() {
    res.hidden = true; box.hidden = false;
    var s = steps[cur];
    var html = '<div class="u4y-gf__step"><div class="u4y-gf__bar"><span class="u4y-gf__count">' +
      esc(T.step.replace('[a]', cur + 1).replace('[b]', steps.length)) + '</span><span class="u4y-gf__dots" aria-hidden="true">' +
      steps.map(function (x, i) { return '<i class="' + (i <= cur ? 'is-on' : '') + '"></i>'; }).join('') + '</span></div>' +
      '<h2 class="u4y-gf__q" tabindex="-1">' + esc(s.q) + '</h2><ul class="u4y-gf__opts' + (s.img ? ' has-img' : '') + '" role="list">';
    s.opts.forEach(function (o) {
      var on = ans[s.k] === o.k;
      html += '<li><button type="button" class="u4y-gf__opt' + (on ? ' is-on' : '') + '" data-k="' + esc(o.k) + '" aria-pressed="' + on + '">' +
        (s.img && o.img ? '<span class="u4y-gf__opt-ph">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy" width="240" height="240" style="object-fit:cover;mix-blend-mode:normal">' : '') + '</span>' : '') +
        '<span class="u4y-gf__opt-l">' + esc(o.l) + '</span>' + (o.sub ? '<span class="u4y-gf__opt-s">' + esc(o.sub) + '</span>' : '') + '</button></li>';
    });
    html += '</ul>';
    if (cur > 0) html += '<button type="button" class="u4y-btn u4y-btn--sec u4y-gf__back" data-back><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>' + esc(T.back) + '</button>';
    box.innerHTML = html + '</div>';
  }
  function focusQ() { var q = box.querySelector('.u4y-gf__q'); if (q) { q.focus({ preventScroll: true }); scrollTop(); } }

  box.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-back')) { cur = Math.max(0, cur - 1); renderStep(); focusQ(); return; }
    var k = b.getAttribute('data-k'); if (!k) return;
    ans[steps[cur].k] = k;
    track('u4y_advisor_answer', { step: steps[cur].k, value: k });
    if (cur < steps.length - 1) { cur++; renderStep(); focusQ(); } else { show(true); }
  });

  function baseUrl() {
    var b = cfg.base;
    steps.forEach(function (s) { var o = opt(s, ans[s.k]); if (o) o.p.forEach(function (x) { if (x[0] === 'col') b = x[1]; }); });
    return b;
  }
  function query(drop) {
    var p = [];
    steps.forEach(function (s) {
      if (drop.indexOf(s.k) >= 0) return;
      var o = opt(s, ans[s.k]); if (o) o.p.forEach(function (x) { if (x[0] !== 'col') p.push(x); });
    });
    p.push(['filter.v.availability', '1'], ['sort_by', 'best-selling']);
    return p.map(function (x) { return encodeURIComponent(x[0]) + '=' + encodeURIComponent(x[1]); }).join('&');
  }
  function load(q) {
    return fetch(baseUrl() + '?' + q + '&section_id=' + cfg.sectionId, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (h) { var d = new DOMParser().parseFromString(h, 'text/html'); var el = d.querySelector('[data-gf-items]'); return { n: el ? parseInt(el.getAttribute('data-count'), 10) || 0 : 0, html: el ? el.innerHTML : '' }; });
  }
  function show(push) {
    var hash = '#wb=' + steps.map(function (s) { return ans[s.k] || 'x'; }).join('.');
    if (push) { try { history.replaceState(null, '', hash); } catch (e) {} }
    box.hidden = true; res.hidden = false;
    res.innerHTML = '<p class="u4y-gf__loading">' + esc(T.loading) + '</p>';
    scrollTop();
    var tries = [[]], acc = [];
    (cfg.loosen || []).forEach(function (k) { if (ans[k] && ans[k] !== 'x') { acc = acc.concat([k]); tries.push(acc.slice()); } });
    var i = 0;
    (function next() {
      var q = query(tries[i]);
      load(q).then(function (r) {
        if (r.n === 0 && i < tries.length - 1) { i++; next(); return; }
        draw(q, r, tries[i]);
      }).catch(function () { res.innerHTML = '<p class="u4y-gf__note">' + esc(T.res_error) + '</p>' + acts(); });
    })();
  }
  function acts(url, n) {
    return '<div class="u4y-gf__acts">' + (url && n > 12 ? '<a class="u4y-btn" href="' + esc(url) + '">' + esc(T.res_all.replace('[n]', n.toLocaleString(document.documentElement.lang || 'de'))) + '</a>' : '') +
      '<button type="button" class="u4y-btn u4y-btn--sec" data-change>' + esc(T.res_change) + '</button>' +
      '<button type="button" class="u4y-btn u4y-btn--sec" data-restart>' + esc(T.res_restart) + '</button>' +
      '<button type="button" class="u4y-gf__copy" data-copy>' + esc(T.copy) + '</button></div>';
  }
  function draw(q, r, dropped) {
    track('u4y_advisor_result', { answers: JSON.stringify(ans), count: r.n, loosened: dropped.join(',') });
    var chips = steps.map(function (s) { var o = opt(s, ans[s.k]); return o && o.k !== 'x' && dropped.indexOf(s.k) < 0 ? '<li>' + esc(o.l) + '</li>' : ''; }).join('');
    var note = '';
    if (dropped.length && r.n > 0) { var dl = dropped.map(function (k) { var ds = stepBy(k); var o = ds ? opt(ds, ans[k]) : null; return o ? o.l : ''; }).filter(Boolean).join(', '); note = '<p class="u4y-gf__note">' + esc(T.res_loose.replace('[x]', dl)) + '</p>'; }
    if (r.n === 0) { res.innerHTML = '<div class="u4y-gf__rhead"><h2 class="u4y-gf__rt" tabindex="-1">' + esc(T.res_none) + '</h2></div>' + acts(); }
    else {
      var head = r.n === 1 ? T.adv_res_one : T.adv_res.replace('[n]', r.n.toLocaleString(document.documentElement.lang || 'de'));
      res.innerHTML = '<div class="u4y-gf__rhead"><h2 class="u4y-gf__rt" tabindex="-1">' + esc(head) + '</h2><p class="u4y-gf__rl">' + esc(T.res_lead) + '</p><ul class="u4y-gf__sum" role="list">' + chips + '</ul>' + note + '</div>' + r.html + acts(baseUrl() + '?' + q, r.n);
    }
    var h = res.querySelector('.u4y-gf__rt'); if (h) h.focus({ preventScroll: true });
  }
  res.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-change')) { cur = steps.length - 1; renderStep(); focusQ(); }
    else if (b.hasAttribute('data-restart')) { ans = {}; cur = 0; try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {} renderStep(); focusQ(); }
    else if (b.hasAttribute('data-copy')) { var done = function () { b.textContent = T.copied; }; if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(done, function () {}); else done(); }
  });

  var m = location.hash.match(/wb=([0-9a-z.]+)/);
  if (m) {
    var parts = m[1].split('.');
    if (parts.length === steps.length && steps.every(function (s, i) { return opt(s, parts[i]); })) {
      steps.forEach(function (s, i) { ans[s.k] = parts[i]; }); cur = steps.length - 1; show(false); return;
    }
  }
  renderStep();
  track('u4y_advisor_start', {});
})();
